var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18.432 15.375",
    "aria-labelledby": "heartIcon heartDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.216 2.449A4.859 4.859 0 005.356.6 4.61 4.61 0 00.6 5.05a4.32 4.32 0 001.6 3.331l7 6.193 6.95-6.128a4.329 4.329 0 001.682-3.4A4.611 4.611 0 0013.076.6a4.859 4.859 0 00-3.86 1.849z"
  })));
}

export default SvgHeart;